<template>
  <div class="A08_jrwm aboutchild">
    <div class="aboutchildbox">
      <div class="title">
        <img src="@/common/images/about/A10_xgsm/titleL.png" alt="" />
        <span>诚聘英才</span>
        <img src="@/common/images/about/A10_xgsm/titleR.png" alt="" />
      </div>
      <div class="zlList">
        <ul>
          <li
            class="lidome"
            v-for="(item, index) in list"
            :key="index"
            @click="toDetail(item.id)"
          >
            <span class="titlespan" :title="item.title">{{ item.title }}</span>
            <span class="time">{{ item.published }}</span>
          </li>
        </ul>
      </div>
      <div class="zlpage">
        <el-pagination
          :key="pages.current"
          id="FY"
          @current-change="pagefun"
          background
          layout="prev, pager, next"
          :total="pages.total"
          :current-page="pages.current"
          :page-size="pages.size"
        >
        </el-pagination>
      </div>
    </div>
  </div>
</template>
<script>
export default {
  name: "A08_jrwm",
  data() {
    return {
      list: [],
      pages: {
        current: 1,
        total: 10,
        size: 10,
      },
    };
  },
  mounted() {
    var cur = localStorage.getItem("cpyc");
    this.pages.current = Number(cur);
    this.getlist();
  },
  methods: {
    getlist: function () {
      var updata = {
        page: this.pages.current,
        limit: this.pages.size,
      };
      this.$api.recruit_list(updata).then((res) => {
        if (res.code == 0) {
          this.list = res.data.list == null ? [] : res.data.list;
          this.pages.total = res.data.total;
          this.list.map(function (item, index) {
            item.published = item.published.split(" ")[0];
          });
        }
      });
    },

    pagefun: function (p) {
      this.pages.current = p;
      localStorage.setItem("cpyc", p);
      this.getlist();
    },
    toDetail: function (id) {
      this.$router.push({
        name: "B08_cpyc",
        query: {
          id: id,
        },
      });
    },
  },
};
</script>
<style scoped>
.aboutchild {
  width: 100%;
  overflow: hidden;
  opacity: 1;
  background: #fff;
}
.aboutchildbox {
  width: 1077px;
  min-height: 940px;
  opacity: 1;
  margin-left: 280px;
  overflow: hidden;
}
.title {
  width: 100%;
  height: 56px;
  display: flex;
  justify-content: center;
  align-items: center;
  margin: 0 auto;
}
.title span {
  display: block;
  height: 56px;
  font-size: 40px;
  font-family: PingFang SC;
  font-weight: bold;
  line-height: 56px;
  color: #1d1d1d;
  opacity: 1;
  margin: 0 50px;
}

.zlList,
.zlpage {
  overflow: hidden;
  margin: 0 auto;
}
.zlpage {
  margin-top: 40px;
  margin-bottom: 60px;
}
.zlList ul {
  overflow: hidden;
}
.lidome {
  width: 1077px;
  height: 91px;
  border-bottom: 1px solid #d5d5d5;
  opacity: 1;
  display: flex;
  justify-content: space-between;
  padding-top: 26px;
  box-sizing: border-box;
  cursor: pointer;
}
.lidome:hover .titlespan {
  color: #e7413b;
}
.lidome:hover .time {
  color: #e7413b;
}
.lidome span {
  display: block;
}
.lidome .titlespan {
  width: 821px;
  height: 65px;
  font-size: 26px;
  font-family: PingFang SC;
  font-weight: 400;
  line-height: 65px;
  color: #333333;
  opacity: 1;
  text-align: left;
  /*  */
  text-overflow: ellipsis;
  overflow: hidden;
  white-space: nowrap;
}
.lidome .time {
  width: 160px;
  height: 65px;
  font-size: 26px;
  font-family: PingFang SC;
  font-weight: 400;
  line-height: 65px;
  color: #666666;
  opacity: 1;
  text-align: right;
}
/* 分页 */
#FY /deep/ .el-pager .number {
  border-radius: 4px;
}
#FY /deep/ .el-pager .active {
  background-color: #e7413b;
}
#FY /deep/ .el-pager .number:not(.active):hover {
  color: #666;
}
</style>


// WEBPACK FOOTER //
// src/components/aboutS/A08_cpyc.vue